/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverShiftAssignmentFormModalClose: "driver-shift-assignment-form-modal-close",
  driverShiftAssignmentFormModalSave: "driver-shift-assignment-form-modal-save",
} as const;
